import { CustomSelect as Select } from 'src/components/common/select'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DENSITY } from 'src/libs/constant/assign'
const SelectDensity = ({ multiple = false, value, onChange }) => {
  const { t } = useTranslation()
  const densityOptions = useMemo(() => {
    return Object.keys(DENSITY).map((key) => ({
      label: t(`constant.density.${key}`),
      value: DENSITY[key]
    }))
  }, [])
  return (
    <Select
      options={densityOptions}
      multiple={multiple}
      allowClear
      placeholder={t('common.label.density')}
      value={value}
      onChange={onChange}
    />
  )
}
export default SelectDensity
